import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-in min-h-[80vh] flex items-center justify-center px-6">
      <form onSubmit={submit} className="card-surface p-10 w-full max-w-md" data-testid="login-form">
        <div className="text-xs uppercase tracking-[0.24em] text-teal-300/80 mb-4">Welcome back</div>
        <h1 className="font-display text-4xl mb-8">Log in</h1>
        <label className="block mb-4">
          <span className="text-xs text-neutral-400 uppercase tracking-wider">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="wwr-input w-full rounded-xl px-4 py-3 mt-1 text-sm"
          />
        </label>
        <label className="block mb-6">
          <span className="text-xs text-neutral-400 uppercase tracking-wider">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="wwr-input w-full rounded-xl px-4 py-3 mt-1 text-sm"
          />
        </label>
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit-btn"
          className="btn-primary w-full py-3 disabled:opacity-60"
        >
          {loading ? "Logging in…" : "Log in"}
        </button>
        <p className="text-sm text-neutral-400 mt-6 text-center">
          New here?{" "}
          <Link to="/signup" data-testid="login-signup-link" className="text-teal-300 hover:text-teal-200">
            Create an account
          </Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
